/* ============================================
   <scroll-carousel-sorlie>
   Sorlie（ソーリー）共通カルーセル
   - iconnav 等で使用
   - scroll-snap ベース、prev/next 矢印で .scrollBy
   - 端到達でボタンを is-disabled 化
   - SPでは矢印を非表示（横スワイプのみ）
   ============================================ */

class ScrollCarouselSorlie extends HTMLElement {
  constructor() {
    super();
    this.list = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this._onScroll = this._onScroll.bind(this);
    this._onResize = this._onResize.bind(this);
    this._rafId = 0;
  }

  connectedCallback() {
    this.list = this.querySelector('[data-scroll-list]');
    this.prevBtn = this.querySelector('[data-scroll-prev]');
    this.nextBtn = this.querySelector('[data-scroll-next]');
    if (!this.list) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._slide(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._slide(1));

    this.list.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize);

    this._update();
  }

  disconnectedCallback() {
    if (this.list) this.list.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
  }

  _slide(direction) {
    if (!this.list) return;
    const firstChild = this.list.children[0];
    const step = firstChild ? firstChild.getBoundingClientRect().width : this.list.clientWidth * 0.8;
    const gap = this._gap();
    this.list.scrollBy({ left: (step + gap) * direction, behavior: 'smooth' });
  }

  _gap() {
    const styles = window.getComputedStyle(this.list);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    return isNaN(gap) ? 0 : gap;
  }

  _onScroll() {
    if (this._rafId) return;
    this._rafId = window.requestAnimationFrame(() => {
      this._rafId = 0;
      this._update();
    });
  }

  _onResize() {
    if (this._rafId) return;
    this._rafId = window.requestAnimationFrame(() => {
      this._rafId = 0;
      this._update();
    });
  }

  _update() {
    if (!this.list) return;
    const max = this.list.scrollWidth - this.list.clientWidth;
    const x = this.list.scrollLeft;
    const atStart = x <= 1;
    const atEnd = x >= max - 1;
    const overflowing = max > 1;
    this.classList.toggle('is-overflowing', overflowing);
    if (this.prevBtn) this.prevBtn.classList.toggle('is-disabled', atStart || !overflowing);
    if (this.nextBtn) this.nextBtn.classList.toggle('is-disabled', atEnd || !overflowing);
  }
}

if (!customElements.get('scroll-carousel-sorlie')) {
  customElements.define('scroll-carousel-sorlie', ScrollCarouselSorlie);
}
